var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleLoop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.607 5C20.137 5 23 8.134 23 12c0 3.784-2.742 6.866-6.169 6.996l-.224.004h-.634l-.015 2L12 18.047 16 15l-.014 2h.62c2.455 0 4.457-2.12 4.563-4.777l.004-.223c0-2.687-1.935-4.879-4.363-4.995L16.607 7h-2.694C13.41 7 13 6.552 13 6c0-.513.353-.936.807-.993L13.913 5h2.694zM8.042 3L12 5.953 8 9l.014-2h-.62C4.938 7 2.936 9.12 2.83 11.777L2.827 12c0 2.687 1.935 4.879 4.363 4.995l.203.005h2.694c.504 0 .913.448.913 1 0 .513-.353.936-.807.993l-.106.007H7.393C3.863 19 1 15.866 1 12c0-3.784 2.742-6.866 6.169-6.996L7.393 5h.634l.015-2zm4.954 6.005c.003.03.004.062.004.093v6.099c0 .443-.36.803-.803.803-.444 0-.804-.36-.804-.803V9.679h-.694c-.386 0-.699-.313-.699-.699 0-.396.301-.727.696-.764l1.21-.113c.55-.052 1.038.352 1.09.902z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleLoop);
export default __webpack_public_path__ + "static/media/single-loop.6c5b45c8.svg";
export { ForwardRef as ReactComponent };